export const getExponentialDelay = () => {
    const retryCount = parseInt(localStorage.getItem("retryCount") || "0");
    const safeRetry = isNaN(retryCount) ? 0 : retryCount;
    const delayList = [10000, 30000, 60000, 120000];
    return delayList[safeRetry] || 120000;
};
